import { render } from "./AboutHuancayo.vue?vue&type=template&id=893b58e4"
import script from "./AboutHuancayo.vue?vue&type=script&lang=js"
export * from "./AboutHuancayo.vue?vue&type=script&lang=js"

import "./AboutHuancayo.vue?vue&type=style&index=0&id=893b58e4&lang=css"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__